module.exports = __webpack_public_path__ + "media/images/icons/twotone/idcard-32b1940ac90d3ffc99411397cf215d95.svg";